import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function UnsubscribePage() {
    const [params] = useSearchParams();
    const email = params.get("e") || "";
    const token = params.get("t") || "";
    const [state, setState] = useState({ done: false, error: email && token ? "" : "Nieprawidłowy link wypisu. Użyj linku z otrzymanej wiadomości.", busy: false });

    const confirm = async () => {
        setState({ done: false, error: "", busy: true });
        try {
            await api.post("/mailing/unsubscribe", { email, token });
            setState({ done: true, error: "", busy: false });
        } catch (err) {
            setState({ done: false, error: formatApiErrorDetail(err.response?.data?.detail), busy: false });
        }
    };

    return (
        <div className="min-h-screen bg-[#FDFDFD]" data-testid="unsubscribe-page">
            <Navbar />
            <main className="max-w-xl mx-auto px-6 pt-40 pb-24 text-center">
                {state.done ? (
                    <div data-testid="unsubscribe-success">
                        <CheckCircle2 size={44} className="mx-auto text-emerald-600 mb-4" />
                        <h1 className="font-serif text-4xl text-[#092E22] mb-3">Wypisano</h1>
                        <p className="text-gray-600">Adres <strong>{email}</strong> nie będzie już otrzymywał wiadomości z listy mailingowej wspólnoty.</p>
                    </div>
                ) : (
                    <>
                        <MailX size={44} className="mx-auto text-[#D4A537] mb-4" />
                        <h1 className="font-serif text-4xl text-[#092E22] mb-3">Wypisz się z mailingu</h1>
                        <p className="text-gray-600 mb-8">Czy na pewno chcesz przestać otrzymywać wiadomości na adres <strong data-testid="unsubscribe-email">{email || "—"}</strong>?</p>
                        {state.error && <p className="text-sm text-red-600 mb-4" data-testid="unsubscribe-error">{state.error}</p>}
                        <button onClick={confirm} disabled={state.busy || !email || !token} data-testid="unsubscribe-confirm"
                            className="px-7 py-3 rounded-full bg-[#0D4F3C] text-white font-medium hover:bg-[#092E22] disabled:opacity-50">
                            {state.busy ? "Przetwarzanie…" : "Tak, wypisz mnie"}
                        </button>
                    </>
                )}
                <div className="mt-10"><Link to="/" className="text-sm text-[#0D4F3C] underline">Wróć na stronę główną</Link></div>
            </main>
            <Footer />
        </div>
    );
}
